import { Pre } from "./Pre";

export interface JsonFieldProps {
  value: unknown;
}

export function JsonField({ value }: JsonFieldProps) {
  return <Pre>{JSON.stringify(value, null, 2)}</Pre>;
}
